export default __webpack_public_path__ + "static/media/SEA_7484.9cdd25e2.jpg";